import React from 'react'
import PropTypes from 'prop-types'
import { pure } from 'recompose'
import DOMPurify from 'dompurify'

const propTypes = {
  children: PropTypes.string,
  tag: PropTypes.string,
  addAttrs: PropTypes.array,
  className: PropTypes.string,
}

const defaultProps = {
  tag: 'div',
  addAttrs: [],
  className: '',
}

function RenderedHtml({ children, tag: Tag, addAttrs, className, ...rest }) {
  if (!children) return null

  // Every rendered rich-text surface gets the shared `rendered-html` class so
  // list markers, blockquotes, and inline colors render consistently (the
  // global Meyer reset strips these otherwise). Callers can still add classes.
  const mergedClassName = ['rendered-html', className].filter(Boolean).join(' ')

  const temporary_attr = 'data-temp-href-target'

  DOMPurify.addHook('beforeSanitizeAttributes', function (node) {
    if (node.tagName === 'A' && node.target === '_blank') {
      node.setAttribute(temporary_attr, node.getAttribute('target'))
    }
  })

  DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if (node.tagName === 'A' && node.hasAttribute(temporary_attr)) {
      node.setAttribute('target', node.getAttribute(temporary_attr))
      node.setAttribute('rel', 'noopener')
      node.removeAttribute(temporary_attr)
    }
  })

  return (
    <Tag
      {...rest}
      className={mergedClassName}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(children, {
          // Keep inline language annotations available for WCAG 3.1.2.
          // `style` is intentionally allowed so authored text colors survive;
          // DOMPurify still sanitizes CSS values (strips url()/expression()).
          ADD_ATTR: Array.from(new Set([...addAttrs, 'lang'])),
        }),
      }}
    />
  )
}

RenderedHtml.propTypes = propTypes
RenderedHtml.defaultProps = defaultProps

export default pure(RenderedHtml)
